import { Link, Outlet } from "react-router-dom";
import loginImage from "@/assets/images/landing/hero/professor-student-hero.jpg";
import logoLight from "@/assets/images/logo/logo-text-light.png";
import { paths } from "@/routes/path";

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-[#F7F8FD]">
      <div className="flex min-h-screen flex-col lg:flex-row">
        <div className="relative hidden w-full max-w-[45%] flex-shrink-0 overflow-hidden lg:block">
          <img
            src={loginImage}
            alt="Kaduna Business School students"
            className="h-full w-full object-cover"
          />
          <div className="absolute left-10 top-10">
            <Link to={paths.public.home.absolute}>
              <img src={logoLight} alt="Kaduna Business School" className="h-12" />
            </Link>
          </div>
        </div>

        <div className="relative h-56 w-full overflow-hidden lg:hidden">
          <img
            src={loginImage}
            alt="Kaduna Business School students"
            className="h-full w-full object-cover"
          />
          <div className="absolute left-6 top-6">
            <Link to={paths.public.home.absolute}>
              <img src={logoLight} alt="Kaduna Business School" className="h-10" />
            </Link>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center px-6 py-10 sm:px-10">
          <div className="w-full max-w-[420px]">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
